/** Generated build artifacts for an Angular library. */
export interface NgArtifacts {

  /** Main JavaScript bundle in UMD (universal-module definition) and ES5 syntax. */
  main: string;

  /** Flat ECMAScript module in ES5 sxntax (FESM'5). */
  module: string;

  /** Flat ECMAScript module in ES2015 syntax (FESM'15). */
  es2015: string;

  /** TypeScript type definition file. */
  typings: string;

  /** Ahead-of-Time metadata (`.metadata.json`) file. */
  metadata: string;
}
